import Tile from "../Tile";
import { grey } from "@mui/material/colors";
import InsuranceSubType from "../../Utility/Crud/InsuranceSubType";
import PropTypes from "prop-types";
import MainContext from "../../Context/MainContext/MainContext";

export default class TileInsuranceSubType extends Tile {
  static contextType = MainContext; // For legacy class components

  /**
   * @returns {string} The InsuranceType name.
   */
  getTitle() {
    return this.props.insuranceSubType
      ? InsuranceSubType.getDisplayName(this.props.insuranceSubType)
      : "None";
  }

  /**
   * @returns {string} The string to be used by the avatar abbreviation
   * formatter.
   */
  getAvatarString() {
    return this.props.insuranceSubType
      ? InsuranceSubType.getDisplayName(this.props.insuranceSubType)
      : null;
  }

  /**
   * @returns {string} The color of the avatar.
   */
  getAvatarColor() {
    return this.props.insuranceSubType
      ? InsuranceSubType.getColor()
      : grey[400];
  }

  /**
   * Renders an icon to represent the avatar if no string is provided.
   */
  renderAvatarIcon() {
    return InsuranceSubType.getIcon();
  }
}
